<template>
  <BaseWrapper :loading="loadingStats || editQuota.loading || loadingChats">
    <div class="space-y-4">
      <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-6">
        <BaseWidget label="Limit" :value="stats.limit">
          <template #label-action>
            <BaseButton size="sm" @click="onOpenEditQuota">Tambah Limit</BaseButton>
          </template>
        </BaseWidget>
        <BaseWidget label="Jumlah Terkirim" :value="stats.current_period_replies_count" />
        <BaseWidget label="Sisa Kuota" :value="`${stats.limit - stats.current_period_replies_count}`" />
      </div>

      <datatable :total="chats.meta.page.total" :perPage="chats.meta.page.perPage"
        :currentPage="chats.meta.page.currentPage" :columns="[
          { id: 'tanggal', name: 'Tanggal' },
          { id: 'phone', name: 'No. Telp' },
          { id: 'type', name: 'Tipe' },
        ]" @pagechanged="onChatsPageChange">
        <template #tbody="{ classes }">
          <tr v-for="chat in chats.data" :key="chat.id" :class="[classes.tr, 'bg-white']">
            <td :class="classes.td">{{ chat.attributes.sent_at | formatDate }}</td>
            <td :class="classes.td">{{ chat.attributes.to_contact_phone_number }}</td>
            <td :class="classes.td">{{ chat.attributes.message_type }}</td>
          </tr>
        </template>
      </datatable>
    </div>

    <BaseConfirm :visible="editQuota.visible" icon-type="badge" type="success" title="Tambah Limit Balas Pesan Whatsapp"
      :disabled="!editQuotaValid" @close="editQuota.visible = false" @confirmed="onConfirmEditQuota">
      <template #content>
        <BaseInput type="number" placeholder="100" :shadow="false" fullwidth v-model="editQuota.input" />
      </template>
    </BaseConfirm>
  </BaseWrapper>
</template>

<script>
import { mapActions } from 'vuex';
import BaseConfirm from '../../../../components/base/BaseConfirm.vue';
import BaseWidget from '../../../../components/base/BaseWidget.vue';
import { requestMixin } from '../../../../mixins/request/request';

export default {
  mixins: [requestMixin],
  components: { BaseWidget, BaseConfirm },
  data() {
    return {
      loadingStats: true,
      loadingChats: true,
      editQuota: {
        visible: false,
        input: 0,
        loading: false
      },
      stats: {
        limit: 0,
        current_period: 0,
        current_period_replies_count: 0,
        current_period_replies_id: []
      },
      chats: {
        data: [],
        meta: {
          page: {}
        }
      }
    }
  },
  computed: {
    editQuotaValid() {
      return this.editQuota.input && Number(this.editQuota.input) > 0
    }
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert'
    }),
    async loadStats() {
      this.loadingStats = true

      const [res, err] = await this.request(`/api/v1/whatsapp-chats/-actions/reply-stats`)

      if (err) {
        this.loadingChats = false
      } else {
        this.stats = res
        this.loadChats()
      }

      this.loadingStats = false
    },
    async loadChats(params) {
      this.loadingChats = true

      const [res, err] = await this.request(`/api/v1/whatsapp-chats`, {
        params: {
          'filter[id]': this.stats.current_period_replies_id.join(','),
          ...params
        }
      })

      if (!err) {
        this.chats = res
      }

      this.loadingChats = false
    },
    onOpenEditQuota() {
      this.editQuota.input = this.stats.limit
      this.editQuota.visible = true
    },
    async onConfirmEditQuota() {
      this.editQuota.loading = true

      const [, err] = await this.request(`/api/v1/whatsapp-chats/-actions/update-reply-limit`, {
        method: 'post',
        data: {
          limit: this.editQuota.input
        }
      })

      if (err) {
        this.createAlert({ status: 'error', data: this.getRequestErrorMessage(err) })
      } else {
        this.stats.limit = this.editQuota.input
        this.createAlert({ status: 'success', data: 'Limit berhasil diperbarui' })

        this.editQuota.visible = false
      }

      this.editQuota.loading = false
    },
    onChatsPageChange(page) {
      this.loadChats({
        'page[number]': page
      });
    }
  },
  created() {
    this.loadStats()
  }
}
</script>